"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = new _immutable.List(['US/Aleutian', 'US/Alaska', 'US/Arizona', 'US/Hawaii', 'US/Samoa', 'US/Indiana-Starke', 'Canada/East-Saskatchewan']);

exports.default = _default;
module.exports = exports.default;